import { Button, Group } from "@mantine/core";
import type { PaginationCursor } from "../hooks/usePaginationCursor";

interface PaginationControlsProps {
  readonly pagination: PaginationCursor;
  readonly isFetching: boolean;
  readonly nextCursor: string | null;
}

export function PaginationControls({
  pagination,
  isFetching,
  nextCursor,
}: PaginationControlsProps) {
  return (
    <Group gap="xs">
      <Button
        size="xs"
        variant="default"
        disabled={!pagination.canGoPrev || isFetching}
        onClick={pagination.goPrev}
      >
        Prev
      </Button>
      <Button
        size="xs"
        variant="default"
        disabled={!nextCursor || isFetching}
        onClick={() => {
          pagination.goNext(nextCursor);
        }}
      >
        Next
      </Button>
    </Group>
  );
}
